import { Button, Dropdown, Form, Label, Modal, Segment } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { MOTIFS_REJET } from '@/constants';

type ModalPrelevementRejetProps = {
  nombreRejets: number;
  onClose: () => void;
  onValidate: (motif: number) => Promise<boolean>;
};

const ModalPrelevementRejet = (props: ModalPrelevementRejetProps) => {
  const { nombreRejets, onClose, onValidate } = props;

  const [motif, setMotif] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<boolean>(null);

  const handleMotifChange = React.useCallback((e, { value }) => {
    setMotif(value);
  }, []);

  const handleValidateClick = React.useCallback(async () => {
    setLoading(true);

    const response = await onValidate(MOTIFS_REJET[motif]);

    if (response) {
      onClose();
    } else {
      setLoading(false);
      setError(true);
    }
  }, [motif, onClose, onValidate]);

  const options = React.useMemo(
    () =>
      _.map(MOTIFS_REJET, (value, index) => ({
        key: `rejet-${index}`,
        value: index,
        text: value,
      })),
    [],
  );

  return (
    <Modal
      open
      size="tiny"
      {...(!loading && {
        closeIcon: true,
        onClose,
      })}
    >
      <Modal.Header>Saisie des rejets de prélèvements</Modal.Header>
      <Modal.Content scrolling={false}>
        {error && (
          <Segment
            basic
            style={{
              marginLeft: '-0.5em',
              padding: 0,
            }}
          >
            <Label color="red" ribbon>
              Une erreur est survenue lors de la saisie du rejet des prélèvements.
            </Label>
          </Segment>
        )}
        <Form>
          <Form.Field>
            <label>
              Veuillez sélectionner le motif de rejet pour{' '}
              {nombreRejets === 1
                ? 'la facture sélectionnée'
                : `les ${nombreRejets} factures sélectionnées`}
            </label>
            <Dropdown
              data-testid="combobox-motif"
              selection
              options={options}
              value={motif}
              onChange={handleMotifChange}
              placeholder="Sélectionnez un motif de rejet"
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close"
          onClick={onClose}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          disabled={loading}
          loading={loading}
        />
        <Button
          data-testid="button-validate"
          positive
          onClick={handleValidateClick}
          content="Confirmer le rejet"
          icon="checkmark"
          disabled={loading || motif === 0}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalPrelevementRejet;
